import React from 'react';
import { InstructorsDataTable } from '@magoosh/b2b/app/organisms/instructors_data_table';

export const Instructors: React.FC = () => (
  <InstructorsDataTable />
);
